import React, { useCallback } from "react";
import { Modal } from "react-bootstrap";

/**
 * Single reusable impurity/deduction modal.
 * Replaces 12 individual modal files (SortedeModal, UnsortedeModal, MixedModal etc.)
 */
const ImpurityModal = ({ show, onClose, category, data, onDeductionChange }) => {
  // Hook above any conditional — Rules of Hooks
  const handleNumericChange = useCallback(
    (e) => {
      const { value } = e.target;
      if (value === "" || /^(0|([1-9][0-9]*))(\.\d{0,2})?$/.test(value)) {
        onDeductionChange(value);
      }
    },
    [onDeductionChange]
  );

  if (!category || !data) return null;

  return (
    <Modal show={show} onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title style={{ fontSize: "16px" }}>
          {category.label} — Reduce Price
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className="mb-3">
          <label className="mb-1 form-label">
            Deduction Percentage for {category.label}
          </label>
          <input
            type="text"
            className="form-control form-control-lg inputStyle"
            placeholder="Enter % deduction"
            value={data.deduction}
            onChange={handleNumericChange}
            disabled={!data.kg || data.kg === "0"}
          />
        </div>
        {data.deduction ? (
          <p style={{ fontSize: "14px", color: "#898989" }}>
            A <strong>{data.deduction}%</strong> deduction will be applied to{" "}
            {category.label}.
          </p>
        ) : null}
      </Modal.Body>

      <Modal.Footer>
        <button
          type="button"
          className="btn loginBtn btn-sm"
          onClick={onClose}
        >
          Done
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default ImpurityModal;